module.exports = __webpack_public_path__ + "static/product-pa70-olive-drab-1f9cd5b14a1fd98746d48d361f7152e2.png";